import restFactory from 'v2/utils/restFactory';

interface CreatePromptHistoryRelatedEntityProps {
  object_id: number;
  model_name: string;
  app_label: string;
  prompt_history: number;
}

export const createPromptHistoryRelatedEntity = ({
  app_label,
  model_name,
  object_id,
  prompt_history,
}: CreatePromptHistoryRelatedEntityProps) => {
  return restFactory.post(`/dj/api/v1/prompt_history_related_entity/`, {
    object_id,
    model_name,
    app_label,
    prompt_history,
  });
};
